import script from "./CalendarWeek.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarWeek.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarWeek.vue?vue&type=style&index=0&id=187de5d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187de5d8"]])

export default __exports__